import { getAppointmentIframeAllowedOrigins } from 'common/env';
import { BOOKING_SOURCE, BookingSource } from 'common/constants';

// Function to get the booking source that owns an appointment iframe origin
export function getBookingSourceFromOrigin(
  origin: string,
): BookingSource | null {
  const { amplar, myhealth } = getAppointmentIframeAllowedOrigins();

  if (amplar.includes(origin)) return BOOKING_SOURCE.AMPLAR;
  if (myhealth.includes(origin)) return BOOKING_SOURCE.MY_HEALTH;

  return null;
}
